import { render } from "./DashboardPerformanceTrendsModal.vue?vue&type=template&id=4f3423e0"
import script from "./DashboardPerformanceTrendsModal.vue?vue&type=script&lang=js"
export * from "./DashboardPerformanceTrendsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__